import {Injectable} from '@angular/core';
import {BzgToastConfig, BzgToastService} from 'bz-genome-angular';
import {BzgToastRef} from 'bz-genome-angular/toast/toast.ref';

@Injectable({
  providedIn: 'root',
})
export class MessageService {

  constructor(private toastService: BzgToastService) {

  }

  messages: string[] = [];

  showError(message: string) {
    this.toastService.open(message, {
      type: 'error',
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 0
    });
  }

  showMessage(message: string, config: BzgToastConfig): BzgToastRef {
    const toastRef = this.toastService.open(message, config);
    return toastRef;
  }

  add(message: string) {
    this.messages.push(message);
  }

  clear() {
    this.messages = [];
  }
}
